import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
  DialogTitle,
  DialogActions,
  Snackbar,
  Alert,
  Autocomplete,
  LinearProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Slide from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddLocationAltRoundedIcon from '@mui/icons-material/AddLocationAltRounded';
import axios from '../../axiosConfig';
import './animation.css';

// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: '#424242',
  fontWeight: '600',
  // textAlign: 'center',
});

const Operation = () => {
  const [tokent, settokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ'
  );
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [open, setOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  // handle snackbar & alert messages on save
  const [openAlert, setopenAlert] = useState(false);
  // At the beginning of the component
  const [openDelete, setOpenDelete] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [operation, setOperation] = useState('Add');
  const [Active, setActive] = useState('Y');
  const [empRole, setEmpRole] = useState('O');

  const [errors, setErrors] = useState({
    opName: false,
    opCategory: false,
    Machine_Id: false,
    emp_role: false,
    Active: false,
    Grade: false,
  });
  const [helperTexts, setHelperTexts] = useState({
    opName: '',
    opCategory: '',
    Machine_Id: '',
    emp_role: '',
    Active: '',
    Grade: '',
  });
  // alert messages on operations
  const [alertType, setAlertType] = useState('success'); // 'success' or 'error'
  const [alertMessage, setAlertMessage] = useState('');

  // input fields state values
  const [IdToDelete, setIdToDelete] = useState(null);
  const [editID, setEditID] = useState();
  const [OperationData, setOperationData] = useState([]);
  const [OpgroupData, setOpgroupData] = useState([]);
  const [machineData, setMachineData] = useState([]);
  const [newOpName, setnewOpName] = useState('');
  const [selectedOpCategory, setselectedOpCategory] = useState(null);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [openLoader, setOpenLoader] = useState(false);
  const [selectedGradeValue, setSelectedGradeValue] = useState(null);
  const [gradeData, setGradeData] = useState([]);

  // API Integration
  useEffect(() => {
    GetAllOperationGroupData();
    GetAllOperationMstData();
    GetAllMachineMstData();
    GetGradeMstData();
  }, []);

  const resetFields = () => {
    setnewOpName('');
    setselectedOpCategory(null);
    setSelectedMachine(null);
    setEmpRole('O');
    setActive('Y');
    errors.opName = false;
    errors.opCategory = false;
    errors.Machine_Id = false;
    errors.emp_role = false;
    errors.Active = false;
    errors.Grade = false;
    helperTexts.opName = '';
    helperTexts.opCategory = '';
    helperTexts.Machine_Id = '';
    helperTexts.emp_role = '';
    helperTexts.Active = '';
    helperTexts.Grade = '';
  };

  const GetGradeMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllGradeMstData`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setGradeData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all op group Request
  const GetAllOperationGroupData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllOperationGroupMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOpgroupData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all machine date
  const GetAllMachineMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllMachineMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setMachineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Cities Request
  const GetAllOperationMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllOperationMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOperationData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // post Request to Add new record
  const addNewOperation = async (newData) => {
    try {
      const res = await axios.instance.post('/InsertOperationMstData', newData, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      GetAllOperationMstData();
      setAlertType('success');
      setAlertMessage(operation === 'Edit' ? 'Operation updated Successfully!' : 'New Operation Added Successfully!');
      setopenAlert(true);
      resetFields();
    } catch (error) {
      console.error('Error adding opName:', error);
      setAlertType('error');
      setAlertMessage(operation === 'Edit' ? 'Failed to Update the Operation!' : 'Failed to add the Operation!');
      setopenAlert(true);
    }
  };

  // delete Request to delete record
  const deleteOperation = async (id2) => {
    try {
      await axios.instance
        .delete(`/DeleteOperationMstData/${id2}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            GetAllOperationMstData();
            setOpenDelete(false);
            setAlertType('warning');
            setAlertMessage('Operation Deleted, Successfully!');
            setopenAlert(true);
          } else {
            GetAllOperationMstData();
            setOpenDelete(false);
            setAlertType('error');
            setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            setopenAlert(true);
          }
        });
    } catch (error) {
      console.error('Error deleting Operation:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete the Operation.');
      setopenAlert(true);
    }
  };

  // submit button on add or edit
  const handleSubmit = (event) => {
    event.preventDefault();
    const inputValidation =
      errors.opName ||
      errors.opCategory ||
      errors.Machine_Id ||
      errors.emp_role ||
      errors.Active ||
      errors.Grade ||
      !Active ||
      !newOpName ||
      !empRole ||
      !selectedOpCategory ||
      selectedOpCategory === null ||
      selectedOpCategory === 0 ||
      selectedOpCategory === undefined ||
      selectedOpCategory === '' ||
      !selectedMachine ||
      selectedMachine === null ||
      selectedMachine === 0 ||
      selectedMachine === undefined ||
      selectedMachine === '' || 
      selectedGradeValue === null ||
      selectedGradeValue === 0 ||
      selectedGradeValue === '' ||
      selectedGradeValue === undefined ;

    if (inputValidation) {
      if (!newOpName) {
        setErrors((prevErrors) => ({ ...prevErrors, opName: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          opName: 'Please enter operation  name ',
        }));
      }
      if (!selectedMachine) {
        setErrors((prevErrors) => ({ ...prevErrors, Machine_Id: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Machine_Id: 'Please select machine ',
        }));
      }
      if (!selectedOpCategory) {
        setErrors((prevErrors) => ({ ...prevErrors, opCategory: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          opCategory: 'please select  category',
        }));
      }
      if (!empRole) {
        setErrors((prevErrors) => ({ ...prevErrors, emp_role: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          emp_role: 'please select employee role',
        }));
      }
      if (!Active) {
        setErrors((prevErrors) => ({ ...prevErrors, Active: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Active: 'please select active status',
        }));
      }
      if (!selectedGradeValue) {
        setErrors((prevErrors) => ({ ...prevErrors, Grade: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Grade: 'Please select grade ',
        }));
      }
    }

    if (inputValidation) {
      return;
    }

    const newAddData = {
      optype: operation === 'Edit' ? 'Edit' : 'Add',
      OperationId: operation === 'Edit' ? editID : '',
      OperationName: newOpName,
      OpGroupId: selectedOpCategory.OP_group_id,
      Machine_Id: selectedMachine.Machine_Id,
      GradeId: selectedGradeValue.GradeValue,
      emp_role: empRole,
      Active,
      [operation === 'Edit' ? 'ModifyedBy' : 'CreatedBy']: sessionStorage.getItem('UserID'),
    };
    addNewOperation(newAddData);
    resetFields();
    handleClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'opName') setnewOpName(value);
    if (name === 'empRole') setEmpRole(value);
    if (name === 'Active') setActive(value);
    validateInput(name, value);
  };

  const handleInputChangeSelect = (event, newValue) => {
    setselectedOpCategory(newValue);

    if (!newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, opCategory: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, opCategory: 'please select operation group' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, opCategory: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, opCategory: '' }));
    }
  };

  const handleInputChangeMachineSelect = (event, newValue) => {
    setSelectedMachine(newValue);
    if (!newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, Machine_Id: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Machine_Id: 'please select machine type' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, Machine_Id: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Machine_Id: '' }));
    }
  };

  const handleGradeInputChangeSelect = (event, newValue) => {
    setSelectedGradeValue(newValue);
    if (!newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, Grade: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Grade: 'please select grade' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, Grade: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Grade: '' }));
    }
  };

  // validations
  const validateInput = (name, value) => {
    let error = false;
    let helperText = '';

    const editedData = value.toLowerCase().trim();

    const isDataExistsinEDIt = OperationData.some(
      (obj) => obj.OperationName.toLowerCase() === editedData && obj.OperationId !== editID
    );

    const isDataExists = OperationData.some((obj) => obj.OperationName.toLowerCase() === editedData);

    if (name === 'opName') {
      if (!value.trim()) {
        // If the field is empty, show a different message
        error = true;
        helperText = 'Opeartion field cannot be empty';
        setIsFormSubmitted(false);
      } else if (operation === 'Add' && isDataExists) {
        error = true;
        helperText = 'Opeartion already exists';
        setIsFormSubmitted(false);
      } else if (operation === 'Edit' && isDataExistsinEDIt) {
        error = true;
        helperText = 'Opeartion already exists';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    }

    // Update the errors and helperTexts states correctly
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      [name]: helperText,
    }));
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    if (value.length > 0) {
      validateInput(name, value);
    }
  };

  // handle edit popup dialog
  const handleAddOpen = () => {
    setOpen(true);
    setOperation('Add');
  };

  // handle edit popup dialog
  const handleEdit = (data) => {
    setEditID(data.OperationId);
    setnewOpName(data.OperationName);
    setEmpRole(data.emp_role);
    setActive(data.Active);
    const selectedMachineObj = machineData.find((obj) => obj.Machine_Id === data.Machine_Id);
    setSelectedMachine(selectedMachineObj);
    const selectedOpCategoryObj = OpgroupData.find((obj) => obj.OP_group_id === data.OpGroupId);
    setselectedOpCategory(selectedOpCategoryObj);
    const selecteGrade = gradeData.find((obj) => Number(obj.GradeValue) === Number(data.GradeId));
    setSelectedGradeValue(selecteGrade);
    handleEditOpen();
  };

  const handleEditOpen = () => {
    setOpen(true);
    setOperation('Edit');
  };

  // handle edit popup dialog
  const handleDelete = (stateId) => {
    setOpenDelete(true);
    setIdToDelete(stateId);
  };
  const handleDeleteConfirmed = (stateId) => {
    deleteOperation(stateId);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setopenAlert(false);
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  const handleClose = () => {
    setOpen(false);
    resetFields();
  };

  // search & filter
  const filteredData = OperationData.filter((c) => c.OperationName.toLowerCase().includes(searchTerm.toLowerCase()));
  // pagination
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  // const currentPage = Math.min(page, totalPages - 1);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1)); // Clamp to the range [0, totalPages - 1]
  // Reset page to 0 when searchTerm changes
  useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  return (
    <>
      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
      <Container maxWidth={'xl'} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #314755, #26a0da)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Operation Master
            </Typography>
          </Typography>
        </Grid>

        {/* search & add button */}
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={2} my={2}>
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
          <Button
            variant="outlined"
            color="secondary"
            sx={{ boxShadow: 1 }}
            onClick={handleAddOpen}
            startIcon={<AddLocationAltRoundedIcon />}
          >
            Add Operation
          </Button>
        </Stack>

        {/* table  */}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">Operation</StyledTableCell>
                <StyledTableCell align="left">Group</StyledTableCell>
                <StyledTableCell align="left">Machine</StyledTableCell>
                <StyledTableCell align="left">Role</StyledTableCell>
                <StyledTableCell align="left">Grade</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : filteredData
              ).map((obj, index) => (
                <TableRow key={index} hover>
                  <TableCell align="center">{obj.SNo}</TableCell>
                  <TableCell align="left">{obj.OperationName}</TableCell>
                  <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                    {obj.op_group_name}
                  </TableCell>
                  <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                    {obj.Machine_name}
                  </TableCell>
                  <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                    {obj.emp_role === 'O' ? 'Operator' : 'Helper'}
                  </TableCell>
                  <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                    {obj.GradeName}
                  </TableCell>
                  <TableCell align="center">
                    {obj.Active === 'Y' ? (
                      <Chip icon={<CheckCircleOutlineIcon />} color="success" size="small" label="Active" />
                    ) : (
                      <Chip icon={<HighlightOffIcon />} color="error" size="small" label="InActive" />
                    )}
                  </TableCell>

                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton aria-label="Edit" onClick={() => handleEdit(obj)}>
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton aria-label="Delete" onClick={() => handleDelete(obj.OperationId)}>
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={5} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          mt={2}
        />
      </Container>

      <Grid m={2}>
        {/* add new popup form dialog box */}
        <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} fullWidth>
          <Container component={Paper} elevation={2} sx={{ py: 2 }}>
            <form onSubmit={handleSubmit} noValidate>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h5" textAlign={'left'} pl={1} fontWeight={600} color="primary">
                  {operation} Operation
                </Typography>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack direction={'column'} spacing={2} p={1}>
                <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      size="small"
                      name="group"
                      options={OpgroupData}
                      getOptionLabel={(obj) => (obj ? obj.op_group_name : '')}
                      value={selectedOpCategory || null}
                      onChange={handleInputChangeSelect}
                      renderInput={(params) => <TextField {...params} label="Operation Group" required />}
                    />
                    {errors.opCategory && (
                      <Typography
                        variant="caption"
                        color="error"
                        pl={1}
                        className={isFormSubmitted && errors.opCategory ? 'shake-helper-text' : ''}
                      >
                        {errors.opCategory && helperTexts.opCategory}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Autocomplete
                      size="small"
                      name="group"
                      options={machineData}
                      getOptionLabel={(obj) => (obj ? obj.Machine_name : '')}
                      value={selectedMachine || null}
                      onChange={handleInputChangeMachineSelect}
                      renderInput={(params) => <TextField {...params} label="Machine" required />}
                    />
                    {errors.Machine_Id && (
                      <Typography
                        variant="caption"
                        color="error"
                        pl={1}
                        className={isFormSubmitted && errors.Machine_Id ? 'shake-helper-text' : ''}
                      >
                        {errors.Machine_Id && helperTexts.Machine_Id}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      type="text"
                      variant="outlined"
                      color="primary"
                      label="Operation"
                      name="opName"
                      value={newOpName}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      fullWidth
                      required
                      size="small"
                      error={errors.opName}
                      helperText={helperTexts.opName}
                      className={isFormSubmitted && errors.opName ? 'shake-helper-text' : ''}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      size="small"
                      name="Grade"
                      required
                      options={gradeData}
                      getOptionLabel={(obj) => (obj ? obj.GradeLable : '')}
                      value={selectedGradeValue || null}
                      onChange={handleGradeInputChangeSelect}
                      renderInput={(params) => <TextField {...params} label="Grade" required />}
                      disableClearable
                    />
                    {errors.Grade && (
                      <Typography
                        variant="caption"
                        color="error"
                        pl={1}
                        className={isFormSubmitted && errors.Grade ? 'shake-helper-text' : ''}
                      >
                        {errors.Grade && helperTexts.Grade}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl size="small" fullWidth component="fieldset" name="empRole">
                      <FormLabel component="legend">Role</FormLabel>
                      <RadioGroup row value={empRole} name="empRole" onChange={handleInputChange}>
                        <FormControlLabel value="O" control={<Radio />} label="Operator" />
                        <FormControlLabel value="H" control={<Radio />} label="Helper" />
                      </RadioGroup>
                      {errors.emp_role && (
                        <Typography
                          variant="caption"
                          color="error"
                          className={isFormSubmitted && errors.emp_role ? 'shake-helper-text' : ''}
                        >
                          {errors.emp_role && helperTexts.emp_role}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl size="small" fullWidth component="fieldset" name="active">
                      <FormLabel component="legend">Active Status</FormLabel>
                      <RadioGroup row value={Active} name="Active" onChange={handleInputChange}>
                        <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                        <FormControlLabel value="N" control={<Radio />} label="No" />
                      </RadioGroup>
                      {errors.Active && (
                        <Typography
                          variant="caption"
                          color="error"
                          className={isFormSubmitted && errors.Active ? 'shake-helper-text' : ''}
                        >
                          {errors.Active && helperTexts.Active}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>

                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  type="submit"
                  sx={{ textTransform: 'capitalize' }}
                >
                  Save
                  {/* {operation} City */}
                </Button>
              </Stack>
            </form>
          </Container>
        </Dialog>

        {/* delete confirmation popup dialog box */}
        <Dialog
          open={openDelete}
          onClose={handleCloseDelete}
          aria-labelledby="alert-dialog-title"
          fullScreen={fullScreen}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle id="alert-dialog-title">{'Are you sure want to Delete?'}</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={() => handleDeleteConfirmed(IdToDelete)} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
      {/* /* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default Operation;
